<template>
  <validation-observer
    ref="form"
    #default="{ invalid }"
  >
    <b-modal
      :id="modalName"
      size="lg"
      ok-only
      :ok-title="$t('save')"
      :ok-disabled="submitSpinner || invalid"
      no-close-on-backdrop
      @ok="onSubmit"
      @hidden="hideModal"
    >
      <template #modal-title="{}">
        <span>
          {{ isUpdated ? $t("Update") : $t("Create") }}
        </span>
        <span> {{ $t("Contact") }}</span>
        <span v-if="isUpdated">{{ form.name }}</span>
      </template>
      <b-form>
        <b-row>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Contact name')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Contact name')"
                vid="name"
                rules="required"
              >
                <b-form-input
                  id="name"
                  v-model="form.name"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Contact name')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Phone')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Phone')"
                vid="name"
                rules="required|phoneNumber"
              >
                <b-form-input
                  id="phone"
                  v-model="form.phone"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Phone')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Contact group')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Contact group')"
                vid="group"
                rules="required"
              >
                <v-select
                  v-model="form.group_id"
                  :options="additionalData.groups"
                  label="name"
                  :reduce="_group => _group.id"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Contact group')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('City')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('City')"
                vid="city"
              >
                <b-form-input
                  id="city"
                  v-model="form.city"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('City')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Company')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Company')"
                vid="company"
              >
                <b-form-input
                  id="company"
                  v-model="form.company"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Company')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Gender')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Gender')"
                vid="gender"
              >
                <v-select
                  v-model="form.gender"
                  :options="additionalData.genders"
                  label="label"
                  :reduce="_gender => _gender.key"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Gender')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Birthday')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Birthday')"
                vid="birthday"
              >
                <date-picker
                  id="birthday"
                  v-model="form.birthday"
                  simple
                  format="YYYY-MM-DD"
                  display-format="jYYYY/jMM/jDD"
                  auto-submit
                  color="#28c76f"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Birthday')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

      </b-form>
      <template #modal-ok="{}">
        <span>
          <b-spinner
            v-if="submitSpinner"
            small
          />
          {{ $t("save") }}
        </span>
      </template>
    </b-modal>
  </validation-observer>
</template>

<script>
import { EditFormLayoutMixin, EditModalMixin } from '../../../common/mixins/form'

export default {
  name: 'ContactsEditModal',
  mixins: [EditFormLayoutMixin, EditModalMixin],
  data() {
    return {
      routeName: 'contacts',
      modalName: 'modal-contacts-edit',
      createAbleFields: [
        'name',
        'phone',
        'group_id',
        'city',
        'company',
        'gender',
        'birthday',
      ],
    }
  },
}
</script>

<style scoped>

</style>
